const defaultMarketplaceConfig = require("./default.json");
const vivamax = require("./vivamax.json");
const astro = require("./astro.json");
const tbonx = require("./tbonx.json");
const demo = require("./demo.json");
const pride = require("./pride.json");
const kandesmart = require("./kandesmart.json");
const questar = require("./questar.json");
const prideon = require("./prideon.json");

const accountConfigs = {
  vivamax,
  astro,
  tbonx,
  demo,
  pride,
  kandesmart,
  questar,
  prideon,
};

const getMarketplaceAccountConfig = (accountId) => {
  const accountConfig = accountConfigs[accountId] || {};

  return Object.keys(defaultMarketplaceConfig).reduce((result, serviceId) => {
    result[serviceId] = {
      ...defaultMarketplaceConfig[serviceId],
      ...(accountConfig[serviceId] || {}),
    };

    return result;
  }, {});
};

const isMarketplaceServiceHidden = (accountId, serviceId) =>
  Boolean(getMarketplaceAccountConfig(accountId)[serviceId]?.hidden);

module.exports = {
  defaultMarketplaceConfig,
  getMarketplaceAccountConfig,
  isMarketplaceServiceHidden,
};
